import { render, staticRenderFns } from "./ToolsPanel.vue?vue&type=template&id=aad7510e"
import script from "./ToolsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolsPanel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports